'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
function escape(str) {
    return str.replace(/[&<>"']/g, function(match) {
        return htmlEscapes[match];
    });
}
exports.escape = escape;
